/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Hardware_InfoInputs */

const en_svr_hardware_info = /** @type {(inputs: Svr_Hardware_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardware Information`)
};

const ja_svr_hardware_info = /** @type {(inputs: Svr_Hardware_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハードウェア情報`)
};

const fr_svr_hardware_info = /** @type {(inputs: Svr_Hardware_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations matérielles`)
};

const de_svr_hardware_info = /** @type {(inputs: Svr_Hardware_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardware-Informationen`)
};

/**
* | output |
* | --- |
* | "Hardware Information" |
*
* @param {Svr_Hardware_InfoInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_hardware_info = /** @type {((inputs?: Svr_Hardware_InfoInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Hardware_InfoInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_hardware_info(inputs)
	if (locale === "ja") return ja_svr_hardware_info(inputs)
	if (locale === "fr") return fr_svr_hardware_info(inputs)
	return de_svr_hardware_info(inputs)
});